import { api } from "@/api";

export async function deletePinnedMarket(marketGroup: number) {
  const res = await api.client.delete(`/pinned-markets/${marketGroup}`);
  return res.data;
}
